import React, { useMemo, useState } from 'react';
import { Spin, Modal, List, Button } from 'antd';
import { PercentageItem } from '../../../Performance/CSV/CSVSummary';
import { useGetClickEmailsByIdAndDateRange } from 'query/mail';
import { flatten } from 'lodash';

type ClicksItemProps = {
  sent: number,
  totalClick: number,
  templateId: number,
  fromDate: string,
  toDate: string,
};

function ClicksItem(props: ClicksItemProps) {
  const [show, setShow] = useState(false);

  const {
    isLoading,
    data,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
  } = useGetClickEmailsByIdAndDateRange({
    id: props.templateId,
    startDate: props.fromDate,
    endDate: props.toDate,
    enabled: show,
  });

  const renderData = useMemo(() => {
    let result = [];
    if (data) {
      result = flatten(data.pages.map(({ data: emails }) => emails));
    }
    return result;
  }, [data]);

  const handleClose = () => setShow(false);

  return (
    <>
      <PercentageItem
        noPercentage
        title="Clicks"
        total={props.sent}
        value={props.totalClick}
        onClick={() => setShow(true)}
      />

      <Modal
        cancelButtonProps={null}
        footer={
          <Button type="primary" onClick={handleClose}>
            Close
          </Button>
        }
        style={{ top: 20 }}
        title="Unique Click Emails"
        visible={show}
        onCancel={handleClose}
        onOk={handleClose}
      >
        <Spin spinning={isLoading}>
          <List
            dataSource={renderData || []}
            footer={
              hasNextPage && (
                <div className="flex" style={{ justifyContent: 'center' }}>
                  <Button
                    loading={isFetchingNextPage}
                    onClick={() => fetchNextPage()}
                  >
                    {isFetchingNextPage ? 'Loading More...' : 'More Items'}
                  </Button>
                </div>
              )
            }
            pagination={{
              size: 'small',
              pageSize: 10,
            }}
            renderItem={item => <List.Item>{item}</List.Item>}
            size="small"
          />
        </Spin>
      </Modal>
    </>
  );
}

export default ClicksItem;
